// export default {
//   cognito: {
//     USER_POOL_ID: 'us-east-1_9I1hERxIr',
//     REGION: 'us-east-1',
//     APP_CLIENT_ID: '1g49q22f7d8ct6rc1cjsg9php2'
//   }
// }

export default {
  cognito: {
    USER_POOL_ID: 'eu-west-2_thNk1OalQ',
    REGION: 'eu-west-2',
    APP_CLIENT_ID: 'i6v8c206nr0ro2465a01uetem'
  }
}
